module.exports = __webpack_public_path__ + "static/avatar_v2-892940ee3dfbbb66289ca665ae5e29ee.gif";